import * as yup from "yup";
import i18next from "i18next";

export default function validation() {
  return yup.object().shape({
    reportCategory: yup
      .string()
      .required(i18next.t("validation.userSupport.reportCategory")),
    reason: yup
      .string()
      .required(i18next.t("validation.userSupport.reportReason"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
  });
}
